// Helper functions
import { useCallback, useMemo } from 'react';
import { getCall } from './Network';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setCurrentPath } from '../slices/navigationSlice';
import PropTypes from 'prop-types';
import useFlagsHook from './useFlags.hook';
import React from 'react';

// Get Wallet Balance function

export const fnGetWalletBalance = async (typeId, customerId) => {
  const apiData = localStorage.getItem('apiToken');
  let bearerToken = '';
  let associateId = customerId;

  if (apiData) {
    const ApiData = JSON.parse(apiData);
    bearerToken = ApiData.jwtToken;
  }

  try {
    const response = await getCall({
      url: 'getWallet',
      urlParams: { AssociateId: associateId, TypeId: typeId },
      headers: { Authorization: `Bearer ${bearerToken}` },
    });

    if (response?.data) {
      return response.data;
    } else {
      return 0;
    }
  } catch (error) {
    console.error('Error fetching wallet balance:', error);
    return 0;
  }
};

// Email Format function
export const fnEmailFormat = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const getMYDDate = (dateString) => {
  let dateStr = dateString.substring(0, 10);

  const [year, month, day] = dateStr.split('-');

  const formattedDate = `${month}-${year}-${day}`;

  return formattedDate;
};

const getDateMonth = (m, y) => {
  const date = new Date(2000, m - 1);
  return date.toLocaleString('en-US', { month: 'short' });
};

export const getMDYDate = (dateString) => {
  if (dateString) {
    let dateStr = dateString.substring(0, 10);

    const [year, month, day] = dateStr.split('-');

    let monthName = getDateMonth(month, year);

    const formattedDate = `${monthName} ${day}, ${year}`;

    return formattedDate;
  }

  return dateString;
};

export const fnSuccessAlert = (arg, message = '') => {
  let successAlert = document.getElementById('success-alert');
  let mesgElm = document.getElementById('success-mesg-elm');

  if (arg === false && successAlert) {
    successAlert.style.display = 'none';
  }

  if (arg === true && successAlert) {
    mesgElm.innerHTML = message;
    successAlert.style.display = 'block';
  }

  setTimeout(function () {
    successAlert.style.display = 'none';
  }, 3000);
};

export const fnWarningAlert = (arg, message = '') => {
  let alertElm = document.getElementById('warning-alert');
  let mesgElm = document.getElementById('warning-mesg-elm');

  if (arg === false && alertElm) {
    alertElm.style.display = 'none';
  }

  if (arg === true && alertElm) {
    mesgElm.innerHTML = message;
    alertElm.style.display = 'block';
  }

  setTimeout(function () {
    alertElm.style.display = 'none';
  }, 3000);
};

export const getSubscriptionExpirationDateByName = (subscriptions, name) => {
  if (!Array.isArray(subscriptions) || !name) return null;

  const subscription = subscriptions.find((sub) => sub.name === name);
  return subscription?.expirationDate ? getMDYDate(subscription.expirationDate) : null;
};

export const isValidSubscription = (sub) => {
  if (!sub?.expirationDate) return false;
  return (
    new Date(sub.expirationDate).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
  );
};

export const hasSubscription = (subscriptions, names) => {
  if (!Array.isArray(subscriptions)) return false;
  const lowerCaseNames = names.map((n) => n.toLowerCase());
  return subscriptions.some(
    (sub) => lowerCaseNames.includes(sub.name?.toLowerCase()) && isValidSubscription(sub)
  );
};

export const hasSubscriptionById = (subscriptions, ids) => {
  if (!Array.isArray(subscriptions)) return false;
  const idSet = new Set(ids.map((id) => Number(id)));
  return subscriptions.some((sub) => {
    return idSet.has(Number(sub.subscriptionId)) && isValidSubscription(sub);
  });
};

hasSubscriptionById.propTypes = {
  subscriptions: PropTypes.array.isRequired,
  ids: PropTypes.array.isRequired,
};

export const hasSubscriptionData = (subscriptions, names) => {
  let filteredSubscriptions = [];
  if (!Array.isArray(subscriptions)) return false;
  const lowerCaseNames = names.map((n) => n.toLowerCase());
  filteredSubscriptions = subscriptions.filter((sub) => {
    return lowerCaseNames.includes(sub.name?.toLowerCase()) && isValidSubscription(sub);
  });

  return filteredSubscriptions.length > 0 ? filteredSubscriptions[0] : {};
};

export const hasRole = (
  userRole,
  allowedRoles = ['Admin', 'ClientAdmin', 'Compliance', 'CustomerService']
) => {
  return allowedRoles.some((role) => role.toLowerCase() === userRole.toLowerCase());
};

export const isValidAutoship = (autoship) => {
  if (!autoship?.nextProcessDate) return false;
  return new Date(autoship.nextProcessDate) >= new Date();
};
const dateStatus = (coupon) => {
  const currentDate = new Date();
  const startDate = new Date(coupon.startDate);
  const endDate = new Date(coupon.endDate);
  if (currentDate < startDate) {
    return 2;
  } else if (currentDate > endDate) {
    return 3;
  } else {
    return 1;
  }
};

export const toCamelCase = (value = '') => {
  if (!value) return '';

  // already camelCase
  if (/^[a-z]+([A-Z][a-z0-9]*)*$/.test(value)) {
    return value;
  }

  return value
    .trim()
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/[^\w\s]/g, '')
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean)
    .map((word, index) =>
      index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join('');
};

export const getDataGridLocaleText = (t) => ({
  paginationRowsPerPage: t('rowsPerPage') || 'Rows per page:',
  paginationDisplayedRows: ({ from, to, count }) =>
    `${from}-${to}  ${t('of')}  ${count !== -1 ? count : `${t('moreThan')} ${to}`}`,
  footerTotalRows: t('totalRows'),

  footerRowSelected: (count) => `${count.toLocaleString()} ${t('rowsSelected')}`,
});

export const handleShortlistViaDate = (coupon) => {
  return [...coupon].sort((a, b) => {
    const statusA = dateStatus(a);
    const statusB = dateStatus(b);
    if (statusA !== statusB) {
      return statusA - statusB;
    }
    if (statusA === 1) {
      return new Date(a.toDate) - new Date(b.toDate);
    }
    if (statusA === 2) {
      return new Date(a.fromDate) - new Date(b.fromDate);
    }
    return 0;
  });
};

export const useOrderSearch = () => {
  const dispatch = useDispatch();
  // Get token safely once
  const { t } = useTranslation();
  const bearerToken = useMemo(() => {
    try {
      const apiToken = localStorage.getItem('apiToken');
      return apiToken ? JSON.parse(apiToken)?.jwtToken : '';
    } catch {
      return '';
    }
  }, []);

  /**
   * Search orders API
   * Returns data instead of navigating
   */
  const searchOrders = useCallback(
    async ({ type = 'ordernumber', search }) => {
      if (!search?.trim()) return [];

      try {
        const response = await getCall({
          url: 'searchOrders',
          urlParams: {
            type,
            search: search.trim(),
          },
          headers: { Authorization: `Bearer ${bearerToken}` },
        });

        if (response?.data?.success) {
          dispatch(setCurrentPath(location.pathname));
          return response || [];
        } else {
          toast.error(t('orderNotExist'));
        }

        return [];
      } catch (error) {
        console.error('Order search error:', error);
        toast.error(t('invalidOrder'));
        return [];
      }
    },
    [bearerToken]
  );

  return { searchOrders };
};

const isEnabled = (value) => {
  return [1, '1', true, 'true'].includes(value);
};

export const withFeatureFlag = ({ flagKey, EnabledComponent, DisabledComponent }) => {
  return function FeatureFlagWrapper(props) {
    const { getFlagValue, loading } = useFlagsHook();

    const enabled = isEnabled(getFlagValue(flagKey.toUpperCase()));

    const Component = enabled ? EnabledComponent : DisabledComponent;

    return !loading && <Component {...props} />;
  };
};

// to replace "X" with "•" in Credit Card Number
export const formatCardNumber = (cardNumber) => {
  if (!cardNumber) return '';
  const replaced = cardNumber.replace(/x/gi, '•');
  const cleaned = replaced.replace(/[^0-9•]/g, '');
  return cleaned.match(/.{1,4}/g)?.join(' ') || '';
};
